import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, {
    icon: "fas fa-ellipsis-h",
    class: "w-min"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_button, {
        class: "primary text small",
        onClick: _ctx.emitUpload
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Загрузить фото ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small",
        onClick: _ctx.emitUpdate
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small",
        onClick: _ctx.emitAddUser
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Создать администратора ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}